import { JOB_SEARCH_LIST_REQUEST_QUERY_PARAM_FOR_CHECK } from '@doda/common/src/constants/queryParams';

export const APPLY_TO_AGENT_SERVICE_URL =
  '/dcfront/member/memberRegist/?entry_id=1&carry_id=5100002287&carry_class=k';

export const HAS_NO_PICTURE = '0';

export const FEATURED_JOB_LIST_SORT = '3';

export const ADDITIONAL_SEARCH_DISABLED = '2';

export const DEFAULT_OFFSET = 0;

export const REMOVE_PARAM_LIST = ['usrclk', 'usrclk_searchList', 'sid'];

export const DEFAULT_PARAMS = {
  ss: '1',
  pic: '1',
  ds: '0',
  tp: '1',
  bf: '1',
  fasetFlg: '0',
};

export const JOB_SEARCH_LIST_REQUEST_QUERY_PARAM_KEYS = Object.values(
  JOB_SEARCH_LIST_REQUEST_QUERY_PARAM_FOR_CHECK
);
